angular.module("Main").factory("BookingService", ["$http", "$q", "NODEBACKEND", "SessionCache",
    function ($http, $q, NODEBACKEND, SessionCache) {
        var settings = null;
        var cycleUnits = [
            ["T_Tag", "T_Tage", "T_täglich"],
            ["T_Woche", "T_Wochen", "T_wöchentlich"],
            ["T_Monat", "T_Monate", "T_monatlich"],
            ["T_Jahr", "T_Jahre", "T_jährlich"]
        ];
        var cachedData = {
            customerData: {}
        };

        return {
            getMandants: getMandants,
            getMandantsAll: getMandantsAll,
            loadLayoutConfiguration: loadLayoutConfiguration,
            getCategoriesAndSubcategories: getCategoriesAndSubcategories,
            getCategoriesAndSubcategoriesSelection: getCategoriesAndSubcategoriesSelection,
            getCurrency: getCurrency,
            createTemporaryMember: createTemporaryMember,
            checkLoginCode: checkLoginCode,
            sendRegistrationEmail: sendRegistrationEmail,
            sendLoginWithCodeEmail:sendLoginWithCodeEmail,
            checkRegisterCode: checkRegisterCode,
            createMember: createMember,
            createMemberAlsGast: createMemberAlsGast,
            createBooking: createBooking,
            createBookingKurs: createBookingKurs,
            findUser: findUser,
            loadAppointmentType: loadAppointmentType,
            confirmReservation: confirmReservation,
            cancelReservation: cancelReservation,
            checkStatus: checkStatus,
            loadClublink: loadClublink,
            getWeekMeetings: getWeekMeetings,
            getResourcesForAppointment: getResourcesForAppointment,
            getResourceNames: getResourceNames,
            getResourceNamesKB: getResourceNamesKB,
            getResourceNamesPayPal: getResourceNamesPayPal,
            getPrivacyText: getPrivacyText,
            getTerminarten: getTerminarten,
            getKurse: getKurse,
            getKurseDay: getKurseDay,
            setOnWaitlistKurs: setOnWaitlistKurs,
            getImage: getImage,
            getTerminImage: getTerminImage,
            loadConfigurationStammdaten: loadConfigurationStammdaten,
            loadMembershipsOnlineSalesLinkConfig: loadMembershipsOnlineSalesLinkConfig,
            loadMembershipsOnlineSales: loadMembershipsOnlineSales,
            getOnlineSalesLayout: getOnlineSalesLayout,
            getMandantsImages: getMandantsImages,
            getBackgrounds: getBackgrounds,
            getMembership: getMembership,
            getMembershipPrices: getMembershipPrices,
            getCycleUnits: getCycleUnits,
            getAppointmentTypeImagePath: getAppointmentTypeImagePath,
            checkEmailForLogin: checkEmailForLogin,
            checkRegistration: checkRegistration,
            checkAppointmentGroupLimit: checkAppointmentGroupLimit,
            checkAppointmentMemberLimit: checkAppointmentMemberLimit,
            getUserDetails: getUserDetails,
            getAllRessources: getAllRessources,
            deleteMemberFromAppointment: deleteMemberFromAppointment,
            getCustomerName: getCustomerName,
            getRegistrationConfig: getRegistrationConfig,
            saveOnlineSalesContract: saveOnlineSalesContract,
            checkMandantOnline: checkMandantOnline,
            getMembershipsByNrs: getMembershipsByNrs,
            getMandantNames: getMandantNames,
            getPrivacyTextOnlineSales: getPrivacyTextOnlineSales,
            isIbanValid: isIbanValid,
            getUserDataByRIDForConfirm: getUserDataByRIDForConfirm,
            getMeetingData: getMeetingData,
            getPaymentMethods: getPaymentMethods,
            getWDR: getWDR,
            saveAppointmentHistory: saveAppointmentHistory,
            saveAppointmentBookingFailedHistory: saveAppointmentBookingFailedHistory,
            getOnlineSalesContractOptions: getOnlineSalesContractOptions,
            checkCoupon: checkCoupon,
            getBlockkursTermine: getBlockkursTermine,
            setOnWaitlistBlockkurs: setOnWaitlistBlockkurs,
            createBookingBlockkurs: createBookingBlockkurs,
            getKursbuchungLayouKonfiguration: getKursbuchungLayouKonfiguration,
            loadLandingPageBSConfig: loadLandingPageBSConfig,
            getTerminartenSelection: getTerminartenSelection,
            checkLinkConfig: checkLinkConfig,
            loadMemberDetails: loadMemberDetails,
            loadMemberContracts: loadMemberContracts,
            loadMemberArticles: loadMemberArticles,
            getCCLinkIdKurse: getCCLinkIdKurse,
            getCCLinkIdTerminbuchung: getCCLinkIdTerminbuchung,
            terminateContract: terminateContract,
            revokeContract: revokeContract,
            revokeArticle: revokeArticle,
            sendRevokeArticleConfirmEmail: sendRevokeArticleConfirmEmail,
            sendRevokeConfirmEmail: sendRevokeConfirmEmail,
            sendTerminateConfirmEmail: sendTerminateConfirmEmail,
            checkSixConfig: checkSixConfig,
            checkPayments: checkPayments,
            getKPConfig: getKPConfig,
            getAppointmentInfosForConfirmWaitlist: getAppointmentInfosForConfirmWaitlist,
            loadNutzungsrechteListe: loadNutzungsrechteListe,
            createTrainerBooking: createTrainerBooking,
            checkRessourcesData: checkRessourcesData,
            checkBarzahlungEndpoint: checkBarzahlungEndpoint,
            checkAltersbeschraenkung: checkAltersbeschraenkung,
            loadBezeichnungStudio: loadBezeichnungStudio,
            loadKPBezeichnungStudio: loadKPBezeichnungStudio,
            loadMembershipBezeichnungStudio: loadMembershipBezeichnungStudio,
            loadMandantMembershipBezeichnungStudio: loadMandantMembershipBezeichnungStudio,
            loadLogo: loadLogo,
            loadShopLogo: loadShopLogo,
            searchMemberWithProperties: searchMemberWithProperties,
            searchAngebotById: searchAngebotById,
            getMemberAngebote: getMemberAngebote,
            saveOnlineSalesAngebot: saveOnlineSalesAngebot,
            getAngeboteTexteConfiguration: getAngeboteTexteConfiguration,
            getMemberAppointments: getMemberAppointments,
            sendMessage: sendMessage,
            sendMessageBlockkurs: sendMessageBlockkurs,
            getVersions: getVersions,
            loadBezeichnungStudioShop: loadBezeichnungStudioShop,
            checkGesamtpreis: checkGesamtpreis,
            getKPFeatureCodeLogin: getKPFeatureCodeLogin,
            createPairing: createPairing,
            loadRegisterReq: loadRegisterReq,
            createTemporaryMemberAggregator: createTemporaryMemberAggregator,
            sendRegistrationAggregatorEmail: sendRegistrationAggregatorEmail,
            loadTextClubs: loadTextClubs,
            loaAggregatorenText:loaAggregatorenText,
            loadRegisterText: loadRegisterText,
            loadCodeText: loadCodeText,
            loadVerifizierungText:loadVerifizierungText,
            loadBestaetigungText: loadBestaetigungText,
            loadBestaetigungButton: loadBestaetigungButton
        };

        function getMandants() {
            return $http.get(NODEBACKEND + "/onlinesales/get/mandants").then(function (response) {
                return response.data;
            });
        }

        function getMandantsAll() {
            return $http.get(NODEBACKEND + "/onlinesales/get/mandants/all").then(function (response) {
                return response.data;
            });
        }

        function loadAppointmentType(nr) {
            return $http.get(NODEBACKEND + "/onlinebooking/appointmenttype/" + nr).then(function (response) {
                return response.data;
            })
        }

        function loadLayoutConfiguration() {
            return $http.get(NODEBACKEND + "/booking/configuration/getonly/layout").then(function (response) {
                return response.data;
            })
        }

        function getCategoriesAndSubcategories() {
            return $http.get(NODEBACKEND + "/onlinebooking/categories/types").then(function (response) {
                return response.data;
            })
        }

        function getCategoriesAndSubcategoriesSelection(ids) {
            let data = {Ids: ids};
            return $http.post(NODEBACKEND + "/onlinebooking/categories/type/selection", data).then(function (response) {
                return response.data;
            })
        }

        function getCurrency() {
            return $http.get(NODEBACKEND + "/onlinebooking/currency").then(function (response) {
                return response.data;
            })
        }

        function findUser(firstName, email) {
            return $http.post(NODEBACKEND + "/booking/find/email", {
                firstname: firstName,
                email: email
            }).then(function (response) {
                return response.data;
            })
        }

        function createTemporaryMember(registration) {
            return $http.post(NODEBACKEND + "/booking/member/temporary", registration).then(function (response) {
                return response.data;
            })
        }

        function checkTemporaryMemberForCodeLogin(code) {
            return $http.post(NODEBACKEND + "/booking/member/temporary/code/login", code).then(function (response) {
                return response.data;
            })
        }

        function sendRegistrationEmail(email, temporaryMember) {
            var data = {email: email, code: temporaryMember.Code};
            return $http.post(NODEBACKEND + "/communication/booking/email/registration", data);
        }

        function sendLoginWithCodeEmail(email, temporaryMember) {
            var data = {email: email, code: temporaryMember.Code};
            return $http.post(NODEBACKEND + "/communication/booking/email/login/code", data);
        }

        function checkRegisterCode(registerData) {
            var data = {email: registerData.email, code: registerData.code};
            return $http.post(NODEBACKEND + "/booking/check/registration/code", data).then(function (response) {
                return response.data;
            });
        }

        function checkLoginCode(emailCode) {
            var data = {email: emailCode.email, code: emailCode.code};
            return $http.post(NODEBACKEND + "/booking/check/login/code", data).then(function (response) {
                return response.data;
            });
        }

        function createMember(registerData) {
            return $http.post(NODEBACKEND + "/onlinebooking/member/new", registerData).then(function (response) {
                return response.data;
            })
        }

        function createMemberAlsGast(registerData) {
            return $http.post(NODEBACKEND + "/onlinebooking/member/new/gast", registerData).then(function (response) {
                return response.data;
            })
        }

        function createBooking(data) {
            return $http.post(NODEBACKEND + "/booking/create", data).then(function (response) {
                return response.data;
            })
        }

        function createBookingKurs(data) {
            return $http.post(NODEBACKEND + "/booking/create/kurs", data).then(function (response) {
                return response.data;
            })
        }


        function setOnWaitlistKurs(data) {
            return $http.post(NODEBACKEND + "/booking/waitlist/kurs", data).then(function (response) {
                return response.data;
            })
        }

        function confirmReservation(orderId, lang, nrs) {
            return $http.put(NODEBACKEND + "/booking/confirm", {orderId: orderId, lang: lang, RessourcenartenNrs: nrs});
        }

        function cancelReservation(orderId, lang, status) {
            return $http.post(NODEBACKEND + "/booking/cancel", {orderId: orderId, lang: lang, status: status});
        }

        function checkStatus(orderId) {
            if (orderId) {
                return $http.get(NODEBACKEND + "/booking/status/" + orderId).then(function (response) {
                    return response.data;
                })
            } else
                return $q.resolve({});
        }

        function loadClublink() {
            return $http.get(NODEBACKEND + "/booking/clublink").then(function (response) {
                return response.data;
            });
        }

        function getWeekMeetings(start, appointmentTypeNr, ressFilter) {
            let end = moment(start).add(6, "days");
            let data = {appointmentTypeNr: appointmentTypeNr, startDate: moment(start).toISOString(), endDate: end.toISOString(), ressIds: ressFilter};
            return $http.post(NODEBACKEND + "/booking/search", data).then(function (response) {
                return response.data;
            });
        }

        function getResourcesForAppointment(appointmentNr) {
            return $http.get(NODEBACKEND + "/onlinebooking/resources/" + appointmentNr).then(function (response) {
                return response.data;
            })
        }

        function getResourceNames(data) {
            //resourceIds = _.map(resourceIds, _.toInteger);
            return $http.post(NODEBACKEND + "/onlinebooking/ressourcenames", {RessourcesData: data}).then(function (response) {
                return response.data;
            })
        }

        function getResourceNamesKB(data, nr) {
            return $http.post(NODEBACKEND + "/onlinebooking/kurs/ressourcenames", {RessourcesData: data, TerminartNr: nr}).then(function (response) {
                return response.data;
            })
        }

        function getResourceNamesPayPal(resourceIds) {
            resourceIds = _.map(resourceIds, _.toInteger);
            return $http.post(NODEBACKEND + "/onlinebooking/namesressources/paypal", {Numbers: resourceIds}).then(function (response) {
                return response.data;
            })
        }

        function getPrivacyText() {
            return $http.get(NODEBACKEND + "/booking/get/privacy").then(function (response) {
                return response.data;
            })
        }

        function getTerminarten() {
            return $http.get(NODEBACKEND + "/booking/kursplan/terminarten").then(function (response) {
                return response.data;
            })
        }

        function getKurse(from, to, id, checkBuchbareKurse, anzahl) {
            var data = {Start: from, Ende: to, Id: id, CheckBuchbareKurse: checkBuchbareKurse, AnzahlWochenZumPruefen: anzahl};
            return $http.put(NODEBACKEND + "/booking/kursplan/week", data).then(function (response) {
                return response.data;
            })
        }

        function getKurseDay(day, id) {
            var date = {Day: day, Id: id};
            return $http.put(NODEBACKEND + "/booking/kursplan/day", date).then(function (response) {
                return response.data;
            })
        }

        function getImage(nr) {
            return $http.get(NODEBACKEND + "/onlinebooking/appointmentType/image/" + nr).then(function (response) {
                return response.data;
            })
        }

        function getTerminImage(nr) {
            return $http.get(NODEBACKEND + "/onlinebooking/termin/appointmentType/image/" + nr).then(function (response) {
                return response.data;
            })
        }

        function loadConfigurationStammdaten() {
            return $http.get(NODEBACKEND + "/booking/configuration/stammdaten").then(function (response) {
                return response.data;
            })
        }

        function loadMembershipsOnlineSales(mandantId) {
            return $http.get(NODEBACKEND + "/onlinesales/s3/salesmanager/memberships/list/" + mandantId).then(function (response) {
                return response.data;
            });
        }

        function loadMembershipsOnlineSalesLinkConfig(mandantId, id) {
            var data = {mandantId: mandantId, id: id};
            return $http.post(NODEBACKEND + "/onlinesales/s3/salesmanager/memberships/list/link", data).then(function (response) {
                return response.data;
            });
        }

        function getOnlineSalesLayout() {
            return $http.get(NODEBACKEND + "/onlinesales/get/config").then(function (response) {
                return response.data;
            })
        }

        function getMandantsImages() {
            return $http.get(NODEBACKEND + "/onlinesales/get/clubimages").then(function (response) {
                return response.data;
            })
        }

        function getBackgrounds() {
            return $http.get(NODEBACKEND + "/onlinesales/get/backgrounds").then(function (response) {
                return response.data;
            })
        }

        function getMembership(id) {
            return $http.get(NODEBACKEND + "/onlinesales/membership/" + id).then(function (response) {
                return response.data;
            })
        }

        function getMembershipsByNrs(nrs) {
            var data = {numbers: nrs}
            return $http.put(NODEBACKEND + "/onlinesales/s3/salesmanager/membershipsByNrs", data).then(function (response) {
                return response.data;
            })
        }

        function getMembershipPrices(id, runtimeId, cycleId) {
            return $http.get(NODEBACKEND + "/onlinesales/membership/prices/" + id + "/" + runtimeId + "/" + cycleId).then(function (response) {
                return response.data;
            })
        }

        function saveOnlineSalesContract(contract) {
            return $http.post(NODEBACKEND + "/onlinesales/s3/salesmanager/onlineSalesContract", contract).then(response => response.data)
        }

        function getCycleUnits() {
            return cycleUnits;
        }

        function getAppointmentTypeImagePath() {
            return NODEBACKEND + "/images/" + SessionCache.get().cid + "/appointmentType/";
        }

        function checkEmailForLogin(data) {
            return $http.get(NODEBACKEND + "/booking/checkLoginEmail/" + data).then(function (response) {
                return response.data;
            })
        }

        function checkRegistration(data) {
            return $http.post(NODEBACKEND + "/booking/checkRegistration", data).then(function (response) {
                return response.data;
            })
        }

        function checkAppointmentGroupLimit(appointmentTypeNr, s3Nr, date) {
            let data = {appointmentTypeNr: appointmentTypeNr, date: date, s3Nr: s3Nr};
            return $http.put(NODEBACKEND + "/appointmentType/check/limit", data).then(function (response) {
                return response.data;
            })
        }

        function checkAppointmentMemberLimit(s3Nr, start, end) {
            let data = {Start: start, Ende: end, S3Nr: s3Nr};
            return $http.put(NODEBACKEND + "/appointmentType/check/memberlimit", data).then(function (response) {
                return response.data;
            })
        }

        function getUserDetails(guid) {
            return $http.get(NODEBACKEND + "/onlinebooking/memberDetails/" + guid).then(function (response) {
                return response.data;
            })
        }

        function getAllRessources() {
            return $http.get(NODEBACKEND + "/onlinebooking/appointmentType/ressources").then(function (response) {
                return response.data;
            })
        }

        function deleteMemberFromAppointment(orderId) {
            return $http.delete(NODEBACKEND + "/onlinebooking/deleteMember/" + orderId).then(function (response) {
                return response.data;
            })
        }

        function getCustomerName() {
            if (_.isEmpty(cachedData.customerData)) {
                return $http.get(NODEBACKEND + "/onlinesales/currentCustomer").then(function (customerData) {
                    cachedData.customerData = customerData.data;
                    return cachedData.customerData.Name;
                });
            } else
                return $q.resolve(cachedData.customerData.Name);
        }

        function checkMandantOnline() {
            return $http.get(NODEBACKEND + "/onlinesales/check/mandant/online").then(function (response) {
                return response.data;
            })
        }

        function getRegistrationConfig() {
            return $http.get(NODEBACKEND + "/onlinebooking/configuration/get/registrationLock").then(function (response) {
                return response.data;
            })
        }

        function getMandantNames() {
            return $http.get(NODEBACKEND + "/onlinesales/get/mandant/name").then(function (response) {
                return response.data;
            })
        }

        function getPrivacyTextOnlineSales() {
            return $http.get(NODEBACKEND + "/onlinesales/set/privacypolicy").then(function (response) {
                return response.data;
            })
        }

        function isIbanValid(iban) {
            return $http.get(`${NODEBACKEND}/onlinesales/iban/${iban}`).then(function (response) {
                return response.data
            })
        }

        function getUserDataByRIDForConfirm(rid) {
            var data = {rid: rid};
            return $http.post(NODEBACKEND + "/onlinebooking/getuserbyrid", data).then(function (response) {
                return response.data;
            })
        }

        function getMeetingData(nr) {
            return $http.get(NODEBACKEND + "/booking/get/meetingdata/" + nr).then(function (response) {
                return response.data;
            })
        }

        function getPaymentMethods() {
            return $http.get(NODEBACKEND + "/onlinesales/paymentMethods").then(function (response) {
                return response.data;
            })
        }

        function saveAppointmentHistory(appNr, actionType, module, actionData, multiUserNr, multiResourceNr) {
            let data = {
                appNr: appNr,
                actionType: actionType,
                actionModule: module,
                data: actionData,
                multiUserNr: multiUserNr,
                multiResourceNr: multiResourceNr
            };
            return $http.post(NODEBACKEND + "/booking/history/appointment", data).catch(function () {
            });
        }

        function saveAppointmentBookingFailedHistory(error, terminNr, userId, controllerName) {
            let data = {
                error: error,
                terminNr: terminNr,
                userId: userId,
                name: controllerName
            };
            return $http.post(NODEBACKEND + "/booking/history/appointment/failed", data).catch(function () {
            });
        }

        function getWDR() {
            return $http.get(NODEBACKEND + "/onlinesales/get/rightofwithdrawal").then(function (response) {
                return response.data;
            })
        }

        function getOnlineSalesContractOptions() {
            return $http.get(NODEBACKEND + "/onlinesales/contractOptions/membership").then(function (response) {
                return response.data;
            })
        }

        function checkCoupon(nr, vertragsartId) {
            var data = {CouponCode: nr, VertragsartId: vertragsartId};
            return $http.post(NODEBACKEND + "/onlinesales/check/coupon", data).then(function (response) {
                return response.data;
            })
        }

        function getBlockkursTermine(nr) {
            return $http.get(NODEBACKEND + "/booking/get/blockkurstermine/" + nr).then(function (response) {
                return response.data;
            })
        }

        function setOnWaitlistBlockkurs(data) {
            return $http.post(NODEBACKEND + "/booking/waitlist/block", data).then(function (response) {
                return response.data;
            })
        }

        function createBookingBlockkurs(data) {
            return $http.post(NODEBACKEND + "/booking/create/blockkurs", data).then(function (response) {
                return response.data;
            })
        }

        function getKursbuchungLayouKonfiguration() {
            return $http.get(NODEBACKEND + "/booking/kursbuchung/layout").then(function (response) {
                return response.data;
            })
        }

        function loadLandingPageBSConfig() {
            return $http.get(NODEBACKEND + "/booking/get/landingpage/online").then(function (response) {
                return response.data;
            })
        }

        function getTerminartenSelection(ids) {
            let data = {Ids: ids};
            return $http.post(NODEBACKEND + "/booking/kursbuchung/appointmentType/selection", data).then(function (response) {
                return response.data;
            })
        }

        function checkLinkConfig(uuid, uuid2) {
            let data = {Id: uuid, Nr: uuid2};
            return $http.post(NODEBACKEND + "/booking/linkConfigGet", data).then(function (response) {
                return response.data;
            })
        }

        function loadMemberDetails(id) {
            return $http.get(NODEBACKEND + "/booking/membermanagement/details/" + id).then(function (response) {
                return response.data;
            })
        }

        function loadMemberContracts(id) {
            return $http.get(NODEBACKEND + "/booking/membermanagement/contracts/" + id).then(function (response) {
                return response.data;
            })
        }

        function loadMemberArticles(id) {
            return $http.get(NODEBACKEND + "/booking/membermanagement/articles/" + id).then(function (response) {
                return response.data;
            })
        }

        function getCCLinkIdKurse() {
            return $http.get(NODEBACKEND + "/booking/cclinkid/kurse").then(function (response) {
                return response.data;
            })
        }

        function getCCLinkIdTerminbuchung() {
            return $http.get(NODEBACKEND + "/booking/cclinkid/termine").then(function (response) {
                return response.data;
            })
        }

        function terminateContract(contractNr, memberNr, date, grund) {
            var data = {ContractId: contractNr, PersonNr: memberNr, EndDate: date, Grund: grund};
            return $http.post(NODEBACKEND + "/booking/terminate/contract", data).then(function (response) {
                return response.data;
            })
        }

        function revokeContract(contractNr, memberNr, grund) {
            var data = {ContractId: contractNr, PersonNr: memberNr, Grund: grund};
            return $http.post(NODEBACKEND + "/booking/revoke/contract", data).then(function (response) {
                return response.data;
            })
        }

        function revokeArticle(article, grund) {
            var data = {RechnungId: article.MVBookingNr, Grund: grund};
            return $http.post(NODEBACKEND + "/booking/revoke/article", data).then(function (response) {
                return response.data;
            })
        }

        function sendRevokeArticleConfirmEmail(articleData, memberId, status, geschlecht) {
            var data = {article: articleData, member: memberId, WiderrufStatus: status, Geschlecht: geschlecht};
            return $http.post(NODEBACKEND + "/booking/revoke/article/email", data).then(function (response) {
                return response.data;
            })
        }

        function sendTerminateConfirmEmail(contractData, memberId, status, geschlecht) {
            var data = {contract: contractData, member: memberId, KuendigungsStatus: status, Geschlecht: geschlecht};
            return $http.post(NODEBACKEND + "/booking/terminate/contract/email", data).then(function (response) {
                return response.data;
            })
        }


        function sendRevokeConfirmEmail(contractData, memberId, status, geschlecht) {
            var data = {contract: contractData, member: memberId, WiderrufStatus: status, Geschlecht: geschlecht};
            return $http.post(NODEBACKEND + "/booking/revoke/contract/email", data).then(function (response) {
                return response.data;
            })
        }

        function checkSixConfig() {
            return $http.get(NODEBACKEND + "/payment/has").then(function (response) {
                return response.data;
            })
        }

        function checkPayments(nr) {
            return $http.get(NODEBACKEND + "/booking/appointmenttype/payments/" + nr).then(function (response) {
                return response.data;
            })
        }

        function getKPConfig() {
            return $http.get(NODEBACKEND + "/booking/kundenportalConfig/get").then(function (response) {
                return response.data;
            })
        }

        function getAppointmentInfosForConfirmWaitlist(nr) {
            return $http.get(NODEBACKEND + "/booking/appointmentinfos/confirm/waitlist/" + nr).then(function (response) {
                return response.data;
            })
        }

        function loadNutzungsrechteListe() {
            return $http.get(NODEBACKEND + "/booking/nutzungsrechte/get").then(function (response) {
                return response.data;
            })
        }

        function createTrainerBooking(data) {
            return $http.post(NODEBACKEND + "/booking/book/trainer", data).then(function (response) {
                return response.data;
            })
        }

        function checkRessourcesData(nrs) {
            let data = {nrs: nrs}
            return $http.post(NODEBACKEND + "/booking/check/ressources", data).then(function (response) {
                return response.data;
            })
        }

        function checkBarzahlungEndpoint() {
            return $http.get(NODEBACKEND + "/booking/barzahlung/get").then(function (response) {
                return response.data;
            })
        }

        function checkAltersbeschraenkung(memberNr, terminartNr, start) {
            let data = {TerminartNr: terminartNr, S3Nr: memberNr, Start: start};
            return $http.put(NODEBACKEND + "/appointmentType/agelimit", data).then(function (response) {
                return response.data;
            })
        }

        function loadBezeichnungStudio(isKurs, linkId) {
            let data = {IsKurs: isKurs, LinkId: linkId}
            return $http.post(NODEBACKEND + "/booking/linkstudioname/get", data).then(function (response) {
                return response.data;
            })
        }

        function loadKPBezeichnungStudio() {
            return $http.get(NODEBACKEND + "/booking/linkkpstudioname/get").then(function (response) {
                return response.data;
            })
        }

        function loadMembershipBezeichnungStudio(linkId) {
            let data = {LinkId: linkId}
            return $http.post(NODEBACKEND + "/booking/linkmsstudioname/get", data).then(function (response) {
                return response.data;
            })
        }

        function loadMandantMembershipBezeichnungStudio(mandantId) {
            let data = {MandantId: mandantId}
            return $http.post(NODEBACKEND + "/booking/linkmandantmembershipstandard/get", data).then(function (response) {
                return response.data;
            })
        }

        function loadLogo(id, isKurs, mandantId) {
            let data = {LinkId: id, IsKurs: isKurs, MandantId: mandantId};
            return $http.post(NODEBACKEND + "/booking/logo/get", data).then(function (response) {
                return response.data;
            })
        }

        function loadShopLogo(id) {
            return $http.get(NODEBACKEND + "/booking/shop/logo/get/" + id).then(function (response) {
                return response.data;
            })
        }

        function searchMemberWithProperties(memberData, abt) {
            memberData.abt = abt;
            return $http.post(NODEBACKEND + "/booking/membermanagement/search", memberData).then(function (response) {
                return response.data;
            })
        }

        function searchAngebotById(id, abt) {
            return $http.get(NODEBACKEND + "/onlinesales/s3/salesmanager/angebot/search/" + id + "/" + abt).then(function (response) {
                return response.data;
            })
        }

        function getMemberAngebote(id, abt) {
            return $http.get(NODEBACKEND + "/onlinesales/s3/salesmanager/memberangebot/search/" + id + "/" + abt).then(function (response) {
                return response.data;
            })
        }

        function saveOnlineSalesAngebot(angebot, email, abt) {
            let data = {SendEmail: email, Angebot: angebot, abt: abt};
            return $http.post(NODEBACKEND + "/onlinesales/s3/salesmanager/onlineSalesAngebot", data).then(response => response.data)
        }

        function getAngeboteTexteConfiguration() {
            return $http.get(NODEBACKEND + "/booking/get/angebotetexte").then(function (response) {
                return response.data;
            })
        }

        function getMemberAppointments(id) {
            return $http.get(NODEBACKEND + "/booking/membermanagement/appointments/" + id).then(function (response) {
                return response.data;
            })
        }

        function sendMessage(appointmentNr, memberNr) {
            let data = {TerminNr: appointmentNr, MemberNr: memberNr}
            return $http.post(NODEBACKEND + "/booking/send/member/message", data).then(function (response) {
                return response.data;
            })
        }

        function sendMessageBlockkurs(appointmentNr, memberNr) {
            let data = {TerminNr: appointmentNr, MemberNr: memberNr}
            return $http.post(NODEBACKEND + "/booking/send/member/message/block", data).then(function (response) {
                return response.data;
            })
        }

        function getVersions() {
            return $http.get(NODEBACKEND + "/booking/get/version").then(function (response) {
                return response.data;
            })
        }

        function checkGesamtpreis(membershipData) {
            return $http.post(NODEBACKEND + "/onlinesales/s3/salesmanager/onlineSalesGesamtpreis", membershipData).then(function (response) {
                return response.data;
            })
        }

        function loadBezeichnungStudioShop(linkId) {
            let data = {LinkId: linkId}
            return $http.post(NODEBACKEND + "/booking/shop/linkstudioname/get", data).then(function (response) {
                return response.data;
            })
        }

        function createPairing(member, provider, code, mandant) {
            let data = {Person: member, Provider: provider, Code: code, Mandant: mandant};
            return $http.post(NODEBACKEND + "/booking/aggregator/pairing", data).then(function (response) {
                return response.data;
            })
        }

        function loadRegisterReq() {
            return $http.get(NODEBACKEND + "/booking/aggregator/configuration/get").then(function (response) {
                return response.data;
            })
        }

        function createTemporaryMemberAggregator(member, provider, mandant) {
            let data = {Member: member, Provider: provider, Mandant: mandant}
            return $http.post(NODEBACKEND + "/booking/member/temporary/aggregator", data).then(function (response) {
                return response.data;
            })
        }

        function sendRegistrationAggregatorEmail(email, temporaryMember) {
            var data = {email: email, code: temporaryMember.verifizierungscode};
            return $http.post(NODEBACKEND + "/communication/booking/email/registration/aggregator", data);
        }

        function loadTextClubs() {
            return $http.get(NODEBACKEND + "/booking/aggregator/configuration/text/clubs/get").then(function (response) {
                return response.data;
            })
        }

        function loaAggregatorenText(mandant) {
            let data = {Mandant: mandant};
            return $http.post(NODEBACKEND + "/booking/aggregator/configuration/text/list/get", data).then(function (response) {
                return response.data;
            })
        }
        function loadRegisterText(mandant, provider) {
            let data = {Mandant: mandant, Provider: provider};
            return $http.post(NODEBACKEND + "/booking/aggregator/configuration/text/register/get", data).then(function (response) {
                return response.data;
            })
        }
        function loadCodeText(mandant, provider) {
            let data = {Mandant: mandant, Provider: provider};
            return $http.post(NODEBACKEND + "/booking/aggregator/configuration/text/code/get", data).then(function (response) {
                return response.data;
            })
        }
        function loadVerifizierungText(mandant, provider) {
            let data = {Mandant: mandant, Provider: provider};
            return $http.post(NODEBACKEND + "/booking/aggregator/configuration/text/verify/get", data).then(function (response) {
                return response.data;
            })
        }
        function loadBestaetigungText(mandant, provider) {
            let data = {Mandant: mandant, Provider: provider};
            return $http.post(NODEBACKEND + "/booking/aggregator/configuration/text/confirm/get", data).then(function (response) {
                return response.data;
            })
        }

        function loadBestaetigungButton() {
            return $http.get(NODEBACKEND + "/booking/aggregator/configuration/button/url/get").then(function (response) {
                return response.data;
            })
        }

        function getKPFeatureCodeLogin() {
            return $http.get(NODEBACKEND + "/booking/kundenportal/feature/code/get").then(function (response) {
                return response.data;
            })
        }

    }]);
